module.exports = __webpack_public_path__ + "media/images/emblems/Croy-coat_of_arms-207791b9edc838e4adafaee321f1af95.svg";